export default __webpack_public_path__ + "static/media/digiimg1.950c8710.jpg";